/** Demo/live banner row (`py-2` + `text-xs`); synced by {@link NetworkModeBanner}. */
const APP_HEADER_BANNER_OFFSET = 'var(--app-header-sticky-banner-offset,2.25rem)';

/** Category strip in app-header.tsx: `pt-1` + nav row + `pb-4`. */
const APP_HEADER_CATEGORY_STRIP = '0.25rem+1.25rem+1rem';

/**
 * Main-row top padding under the fixed {@link AppHeader}.
 * `--app-header-chrome-height` is measured by {@link AppHeader}; the token
 * fallback in `tokens.css` matches full chrome (incl. category) until hydration.
 */
export const APP_HEADER_CHROME_PADDING_CLASS = 'pt-[var(--app-header-chrome-height)]' as const;

/** In-page anchor targets below the fixed header. */
export const APP_HEADER_SCROLL_MARGIN_CLASS =
  'scroll-mt-[var(--app-header-chrome-height,4rem)]' as const;

/**
 * Sticky `top` for columns that sit below {@link AppHeader}.
 * `--app-header-sticky-banner-offset` is set by {@link NetworkModeBanner};
 * fallback matches the banner's `min-h-9`. Remainder matches app-header.tsx:
 * `h-16`, category strip, plus `1rem` clearance below the header.
 */
export const APP_HEADER_STICKY_TOP_SIDEBAR_CLASS =
  `top-[calc(${APP_HEADER_BANNER_OFFSET}+4rem+${APP_HEADER_CATEGORY_STRIP}+1rem)]` as const;
